/*
 * Selectors using reselect.
 */
import { createSelector } from 'reselect';

const rootSelector = state => state.app.global;

export const goingBackSelector = createSelector(
  rootSelector,
  subState => subState.goingBack
);

export const tokenSelector = createSelector(
  rootSelector,
  subState => subState.token
);

export const bookingSourceSelector = createSelector(
  rootSelector,
  subState => subState.bookingSource
);

export const guestProfilesSelector = createSelector(
  rootSelector,
  subState => subState.guestProfiles
);

export const bookingCommentsSelector = createSelector(
  rootSelector,
  subState => subState.bookingComments
);

export const inMobileAppSelector = createSelector(
  rootSelector,
  subState => subState.inMobileApp
);
